import { render, staticRenderFns } from "./upgradeAi.vue?vue&type=template&id=7dcdab0c&scoped=true"
import script from "./upgradeAi.vue?vue&type=script&lang=js"
export * from "./upgradeAi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcdab0c",
  null
  
)

export default component.exports